<template>
  <!-- 原材料库存订单 -->
  <div>
    <div class="container">
      <ESearch
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
      />
    </div>
    <div class="plan-tips">
      <p>
        <span>功能说明：</span>
        中国石化打造对原材料产业链全程可追溯，原材料库存订单管理适用于以下场景，请根据实际情况提报历史库存订单信息：
      </p>
      <p>1.用库存原料进行生产，但该原料未在易派客2.0平台采购；</p>
      <p>2.使用在途原料进行生产；</p>
      <p>3.部分使用库存原材料进行生产。</p>
      <p>
        新建原材料库存订单并关联石化采购意向单，准确提报本次生产所需的原材料库存信息。
      </p>
    </div>
    <div class="container">
      <div class="handle-wrapper flex-sb">
        <eui-btn @click="goToNew">新建</eui-btn>
        <eui-btn @click="ecStockExport">导出</eui-btn>
      </div>
      <TableList
        :table-data="tableData"
        index-show
        :loading="loading"
        :table-label="tableLabel"
      >
        <template #aiCheckResultHeader>
          <div class="flex-all-center">
            AI审查建议结果
            <eui-tooltip :content="aiCheckResultTip" placement="top">
              <eui-icon
                icon="eicon-r-changjianwenti"
                font-size="14px"
                color="#666666"
              />
            </eui-tooltip>
          </div>
        </template>
        <template #price="{ scope: { row } }">
          <span style="color: red">{{ formattedPrice(row.price) }}</span>
        </template>
        <template #aiCheckResult="{ scope: { row } }">
          <div
                  :class="{
              'color-red':
                row.aiCheckResult && row.aiCheckResult === '审查不通过',
            }"
                  @click="showCheckResult(row.requestId, row.aiCheckResult)"
          >
            {{ row.aiCheckResult }}
          </div>
        </template>
        <template #handle="{ scope: { row } }">
          <eui-btn type="link" font-size="12px" @click="goToDetail(row)"
            >查看详情</eui-btn
          >
          <eui-btn type="link" font-size="12px" @click="goToEdit(row)"
            >编辑</eui-btn
          >
          <eui-btn
            type="link"
            color="error"
            font-size="12px"
            @click="handleDelete(row)"
            >删除</eui-btn
          >
        </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :total="total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!--AI审查建议结果-->
    <!--type:1:sku;2:库存单;3:采购意向单成品现货；4：石化商城成品现货-->
    <AIDataReport
      v-if="dataReportVisible"
      :dataReportVisible.sync="dataReportVisible"
      type="2"
      :target-id="targetId"
    />
  </div>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search';
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import api from '@/modules/projectA/api/order';
import _ from 'lodash';
import utils from '@/modules/projectA/utils/utils';
import {
  fieldList,
  listTypeInfo,
  tableLabel,
  formattedPrice,
} from '../common/stockOrder';
import AIDataReport from '../../../components/common/AIDataReport';
import {epecMallUrl} from '@/modules/projectA/api/config';

export default {
  components: {
    TableList,
    ESearch,
    AIDataReport,
  },
  props: {},
  data() {
    return {
      dataReportVisible: false,
      targetId: '',

      listTypeInfo,
      fieldList,
      listQuery: {
        brandName: '',
        brandNameEN: '',
        brandAuditStatus: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      loading: false,
      tableLabel,
      aiCheckResultTip:
        'AI审查建议结果仅作为业务处理的参考依据，不会中断或者阻止正常业务流程。',
    };
  },
  computed: {},
  created() {
    this.cloneListQuery = _.cloneDeep(this.listQuery);
    this.getList(this.query);
  },
  methods: {
    showCheckResult(requestId, aiCheckResult) {
      if (aiCheckResult === '审查不通过') {
        // console.log(id,'gggg');
        // this.targetId = id;
        // this.dataReportVisible = true;
        window.open(`${epecMallUrl}/intelligentReview?id=${requestId}`, '_blank');
      }
    },
    // 导出
    async ecStockExport() {
      const res = await api.ecStockExport(this.listQuery);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '原材料库存单信息');
      }
    },
    async deleteRow(id) {
      const { code = -1 } = await api.ecStockDelete({ id });
      if (code === '200') {
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
        this.handleClear();
      }
    },
    // 大于等于 1，提示;小于1直接调删除接口
    async handleDelete(row) {
      const { id } = row;

      this.$confirm(
        '您正在操作删除原材料库存单，删除后将取消与石化订单关联关系，并无法恢复，是否确认？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.deleteRow(id);
      });

      // const res = await api.bindCount({id: id});
      // if (res.code === '200') {
      //   if (Number(res.data) < 1) {
      //     this.deleteRow(id);
      //   } else {
      //
      //   }
      // }
    },
    formattedPrice,
    goToDetail(row) {
      const { id } = row;
      this.$router.push({
        name: 'StockDetail',
        params: {
          id,
        },
      });
    },
    goToEdit(row) {
      const { id } = row;
      this.$router.push({
        path: '/rawMaterialOrder/stockOrder/newStock',
        query: {
          id,
        },
      });
    },
    goToNew() {
      this.$router.push({
        name: 'NewStock',
      });
    },
    async getList(params) {
      try {
        const { ecStockQueryPage } = api;
        this.loading = true;
        const res = await ecStockQueryPage(params);
        if (res.code === '200') {
          const { data: { records = [], total = 0 } = {} } = res || {};
          this.tableData = [...records];
          this.total = total;
        }
      } catch (error) {
        console.error(error);
        // this.tableData = [];
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    handleSearch(val) {
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleClear() {
      this.listQuery = {
        ...this.cloneListQuery,
      };
      this.getList(this.listQuery);
    },
  },
};
</script>

<style scoped lang="scss">
.plan-tips {
  background: #e8efff;
  padding: 15px 0 15px 10px;
  margin-bottom: 10px;
  span {
    color: #f0250f;
  }
}

.color-red {
  color: #f0250f;
  cursor: pointer;
}
</style>
